import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Import and register controllers
import FormPendingController from "./form_pending_controller";
application.register("form-pending", FormPendingController);

import MaskController from "./mask_controller";
application.register("mask", MaskController);

import MembersController from "./members_controller";
application.register("members", MembersController);

import PropertySelectController from "./property_select_controller";
application.register("property-select", PropertySelectController);

import MemberSelectController from "./member_select_controller";
application.register("member-select", MemberSelectController);

import ConditionalFieldsController from "./conditional_fields_controller";
application.register("conditional-fields", ConditionalFieldsController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import AccountSearchController from "./account_search_controller";
application.register("account-search", AccountSearchController);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import SubmitButtonController from "./submit_button_controller";
application.register("submit-button", SubmitButtonController);

import MultiFileUploadController from "./multi_file_upload_controller";
application.register("multi-file-upload", MultiFileUploadController);

import PrimaryMemberChangeConfirmController from "./primary_member_change_confirm_controller";
application.register("primary-member-change-confirm", PrimaryMemberChangeConfirmController);

import WaiveConfirmController from "./waive_confirm_controller";
application.register("waive-confirm", WaiveConfirmController);

import RefundSelectController from "./refund_select_controller";
application.register("refund-select", RefundSelectController);

import GateKioskScanController from "./gate_kiosk_scan_controller";
application.register("gate-kiosk-scan", GateKioskScanController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import VoteCapController from "./vote_cap_controller";
application.register("vote-cap", VoteCapController);

export { application };
